import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const [accessToken, setAccessToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    setAccessToken(userData.access_token);
  }, []);

  useEffect(() => {
    const handleUnauthorized = (event) => {
      if (event.detail.status === 401 || !accessToken) {
        console.error(accessToken ? "unauthorized access" : "No access token");
        localStorage.removeItem("userData"); // Clear user data on unauthorized access or missing access token
        navigate("/login");
      }
    };

    window.addEventListener("unauthorized", handleUnauthorized);
    return () => window.removeEventListener("unauthorized", handleUnauthorized);
  }, [navigate]);

  return { accessToken, setAccessToken };
};
